import React from 'react';
import SpinnerIcon from "../../assets/icons/spinner";

export default function Spinner() {
    return (
        <div className="h-full w-full flex justify-center items-center">
            <div className="w-1/12">
                <SpinnerIcon />
            </div>
        </div>
    );
}
